import React from 'react';
import { useSelector } from 'react-redux';
import { seoStateSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import ListForLinks from '@stencil/commonstories/src/components/Seo/list-for-links/list-for-links';

const SeoStaticPagesLeft = props => {
  const seoState = useSelector(seoStateSelector);
  const { staticBlocks = [] } = seoState;

  return (
    <>
      {staticBlocks.map((staticBlock, index) =>
        staticBlock ? (
          <ListForLinks
            key={index}
            title={staticBlock.title}
            html={staticBlock.api_url}
            links={[]}
            isDweb={true}
          />
        ) : null
      )}
    </>
  );
};

export default SeoStaticPagesLeft;
